import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/shared/lib';

import { SETTINGS_TABS } from '../model/nav';

/** Pills on mobile, a sticky vertical list from md up. */
export const SettingsNav = () => {
  const { t } = useTranslation('settings');
  const { pathname } = useLocation();

  const links = (variant: 'pill' | 'row') =>
    SETTINGS_TABS.map(({ id, icon: Icon, path }) => {
      const active = pathname.startsWith(path);
      return (
        <Link
          key={id}
          to={path}
          aria-current={active ? 'page' : undefined}
          className={
            variant === 'pill'
              ? cn(
                  'flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors',
                  active
                    ? 'bg-primary text-white'
                    : 'border border-transparent bg-gray-100 text-gray-600',
                )
              : cn(
                  'flex items-center gap-3 rounded-xl px-4 py-3 font-medium transition-colors',
                  active
                    ? 'bg-primary text-white shadow-md shadow-primary/20'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-dark',
                )
          }
        >
          <Icon size={variant === 'pill' ? 16 : 20} />
          {t(`nav.${id}`)}
        </Link>
      );
    });

  return (
    <div className="w-full shrink-0 md:w-[240px]">
      <nav
        aria-label={t('nav.label')}
        className="mb-4 flex scrollbar-none gap-2 overflow-x-auto border-b border-gray-100 pb-4 md:hidden"
      >
        {links('pill')}
      </nav>
      <nav aria-label={t('nav.label')} className="sticky top-[40px] hidden flex-col gap-2 md:flex">
        {links('row')}
      </nav>
    </div>
  );
};
